// Row 17.1 — i18n framework adoption. react-i18next/i18next chosen (battle-tested, MIT, the
// de facto React standard) over extending features/vc/api/i18n.ts's bespoke bundle-fetching
// mechanism — that mechanism is scoped to the legacy VC app (itself being dissolved per the
// VC-DISSOLUTION decision), not a shell-wide or locked choice.
//
// Locale is BROWSER-DETECTED only this batch, with NO manual switcher and NO persistence
// (CFR-I18N01-15): real per-actor persistence needs a new `account_profile.locale_preference`
// column, which this session has no migration token for. Detection is real and tested even
// though only the "en" resource bundle has real content today — i18next's own `fallbackLng`
// handles any detected locale that isn't yet translated.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";

export function detectBrowserLocale(): string {
  if (typeof navigator !== "undefined" && navigator.language) {
    return navigator.language;
  }
  return "en";
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: detectBrowserLocale(),
  fallbackLng: "en",
  interpolation: { escapeValue: false }, // React already escapes
});

export { i18n };
